// Get the customModalBtn element
const customModalBtn = document.getElementById("customModalBtn");

// Get the customModalOptin div element
const customModalOptin = document.getElementById("customModalOptin");

// When the customModalBtn element is clicked, show the customModalOptin div element
customModalBtn.addEventListener("click", () => {
  customModalOptin.style.display = "block";
});

// Get the customModalClose element
const customModalClose = document.getElementsByClassName("customModalClose");

// When the customModalClose element is clicked, close the customModalOptin div element
for (const close of customModalClose) {
  close.addEventListener("click", () => {
    customModalOptin.style.display = "none";
  });
}

// When the user clicks outside the modal, close it
document.addEventListener("click", (event) => {
  if (event.target === customModalOptin) {
    customModalOptin.style.display = "none";
  }
});
